import { type RouteObject } from 'react-router-dom-v6'
import AppLayout from './components/AppLayout'
import RouteError from './components/RouteError'
import { ChangePassword, LocaleSettings, Profile } from './features/account'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Profile /> },
      { path: 'locale', element: <LocaleSettings /> },
      { path: 'password', element: <ChangePassword /> },
    ],
  },
]
